// eslint-disable-next-line import/prefer-default-export
import { keyframes } from '@emotion/react';

const getMonth = (date) => date.toLocaleString('default', { month: 'short' });

export const getCurrentWeekString = (startDate, endDate) => {
  const startDateObj = {
    date: startDate.getDate(),
    month: getMonth(startDate)
  };
  const endDateObj = {
    date: endDate.getDate(),
    month: getMonth(endDate)
  };

  const weekString =
    startDateObj.month === endDateObj.month
      ? `${startDateObj.date} - ${endDateObj.date} ${endDateObj.month}`
      : `${startDateObj.date} ${startDateObj.month} - ${endDateObj.date} ${endDateObj.month}`;

  return weekString;
};

export const getRemainingHours = (currentDate, endDate) =>
  parseInt((endDate - currentDate) / (1000 * 60 * 60), 10);

export const getRemainingTimeString = (currentDate, endDate) => {
  const remainingHours = getRemainingHours(currentDate, endDate);
  if (remainingHours > 24) {
    const remainingDays = Math.floor(remainingHours / 24);
    return remainingDays <= 1
      ? `${remainingDays} day`
      : `${remainingDays} days`;
  }
  if (remainingHours <= 24 && remainingHours > 1) {
    return `${remainingHours} hrs`;
  }
  return '1 hr';
};

export const getDayStatus = (currentDate) => {
  const currentHour = currentDate.getHours();
  if (currentHour < 12) {
    return 'morning';
  }
  if (currentHour < 18) {
    return 'afternoon';
  }
  return 'night';
};

export const isInvitationJoiningFailed = (errorObj = {}) =>
  Object.keys(errorObj).length > 0;

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const minUsersToDisplay = 12;

export const keyFrameOpen = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const keyFrameClose = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;
